import { themes } from "../TheHousingHubTheme/initThemes";
import layout1Settings from "./Layout1/Layout1Settings";

// UPDATE BELOW CODE
// DOC http://demos.ui-lib.com/TheHousingHub-react-doc/layout.html
export const TheHousingHubLayoutSettings = {
  activeLayout: "layout1", // layout1, layout2
  activeTheme: "blue", // View all valid theme colors inside TheHousingHubTheme/themeColors.js
  perfectScrollbar: false,

  themes: themes,
  layout1Settings, // open Layout1/Layout1Settings.js

  secondarySidebar: {
    show: false,
    open: false,
    theme: "slateDark1" // View all valid theme colors inside TheHousingHubTheme/themeColors.js
  },
  // Footer options
  footer: {
    show: false,
    fixed: false,
    theme: "slateDark1" // View all valid theme colors inside TheHousingHubTheme/themeColors.js
  }
};
